let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3TrjM")).then(() => parcelRequire('1O92x'));